// extracted by mini-css-extract-plugin
module.exports = {"container":"not-found_container__2VxoH","notFoundSection":"not-found_notFoundSection__1emlq"};